export default __webpack_public_path__ + "static/media/no-avatar.9dc20c51.png";